import DirectionalButtonWrapper from "./DirectionalButtonWrapper";
import ButtonWrapper from "./ButtonWrapper";
import { getPaginationInterval } from "@lib/helpers";

const PaginationWithLinks = ({ pagination = [] }) => {
  const paginationCopy = pagination.map((p) => ({ ...p }));
  const activeInitialIndex = paginationCopy.findIndex((e) => e.active);
  const defaultIndex = paginationCopy.findIndex((e) => e.default);
  const activeIndex =
    activeInitialIndex > -1
      ? activeInitialIndex
      : defaultIndex > -1
      ? defaultIndex
      : 0;

  // we need paginationCopy because after interval the activeIndex is no longer valid
  paginationCopy[activeIndex].active = true;

  const paginationWithInterval = getPaginationInterval(
    paginationCopy,
    activeIndex
  );

  return (
    <nav className="flex flex-wrap items-center py-3">
      <DirectionalButtonWrapper
        url={activeIndex > 0 ? paginationCopy[activeIndex - 1].url : null}
      >
        <div className="hidden md:inline-block">Pagina anterioara</div>
        <div className="Toolbar-previous md:hidden"></div>
      </DirectionalButtonWrapper>

      <ol className="flex list-none m-0 p-0">
        {paginationWithInterval.map((page, i) => (
          <>
            {(parseInt(page.name) <= 20 || page.name === "...") && (
              <li key={`${page.name}-${i}`}>
                <ButtonWrapper url={page.url} isActive={page.active}>
                  {page.name}
                </ButtonWrapper>
              </li>
            )}
          </>
        ))}
      </ol>

      <DirectionalButtonWrapper
        url={
          activeIndex < paginationCopy.length - 1
            ? paginationCopy[activeIndex + 1].url
            : null
        }
      >
        <div className="hidden md:inline-block">Pagina urmatoare</div>
        <div className="Toolbar-next md:hidden"></div>
      </DirectionalButtonWrapper>
    </nav>
  );
};

export default PaginationWithLinks;
